module.exports = __webpack_public_path__ + "img/sys-icon-0.f7c1ab8.png";